export enum LearningHistoryTypes {
    PERIOD = 'period',
    MAX ='max',
    NOW = 'now',
    TIME_OF_FORGETTING = 'timeOfForgetting'
}

export interface LearningHistoryResponseDto {
    type: LearningHistoryTypes;
    periodStartDate: string;
    periodEndDate: string;
    reliableLearningProgress: number;
    forgetting: number;
    isProjection: boolean;
    amountOfCorrectAnswers: number;
    amountOfWrongAnswers: number;
    predictedConfidence: number;
}

